import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HttpService {

  baseApiUrl = environment.API_BASE_URL;
  private headers: HttpHeaders = new HttpHeaders();

  constructor(private http: HttpClient) { }

  private setHeaders() {
    this.headers = new HttpHeaders();
    this.headers = this.headers.set("Content-Type", "application/json");
    this.headers = this.headers.set("Accept", "application/json");

    let myRawToken = localStorage.getItem('token');
    if (myRawToken)
      this.headers = this.headers.set("Authorization", "Bearer " + myRawToken);
  }


  postData(subURL, setAuth, postData, fileExport?: Boolean): any {
    this.setHeaders();
    return new Promise((resolve, reject) => {
      if (setAuth && fileExport == undefined) {
        console.log('Not File Export ' + fileExport)
        this.http.post(this.baseApiUrl + subURL, postData, { headers: this.headers }).subscribe(res => {
          resolve(res);
        }, (err) => {
          console.log('In http service error ' + err)
          reject(err);
        });
      }
      else if (setAuth && fileExport != undefined) {
        console.log('File Export ' + fileExport)
        this.http.post(this.baseApiUrl + subURL, postData, { responseType: 'blob', headers: this.headers }).subscribe(res => {
          resolve(res);
        }, (err) => {
          console.log('In http service error ' + err)
          reject(err);
        });
      }
      else {
        this.http.post(this.baseApiUrl + subURL, postData).subscribe(res => {
          resolve(res);
        }, (err) => {
          console.log('In http service error ' + err)
          reject(err);
        });
      }

    });
  }

  putData(subURL, setAuth, postData) {
    this.setHeaders();
    return new Promise((resolve, reject) => {
      if (setAuth) {
        this.http
          .put(this.baseApiUrl + subURL, postData, { headers: this.headers })
          .subscribe(
            res => {
              resolve(res);
            },
            err => {
              console.log("In http service error " + err);
              reject(err);
            }
          );
      } else {
        this.http.put(this.baseApiUrl + subURL, postData).subscribe(
          res => {
            resolve(res);
          },
          err => {
            console.log("In http service error " + err);
            reject(err);
          }
        );
      }
    });
  }

  getData(subURL: string, setAuth) {
    this.setHeaders();
    return new Promise((resolve, reject) => {
      if (setAuth) {
        this.http
          .get(this.baseApiUrl + subURL, { headers: this.headers })
          .subscribe(
            res => {
              resolve(res);
            },
            err => {
              console.log("In http service error " + err);
              reject(err);
            }
          );
      } else {
        this.http.get(this.baseApiUrl + subURL).subscribe(
          res => {
            resolve(res);
          },
          err => {
            console.log("In http service error " + err);
            reject(err);
          }
        );
      }
    });
  }

  private setFileHeaders() {
    this.headers = new HttpHeaders();
    this.headers = this.headers.set("Content-Type", "application/octet-stream");
    // this.headers = this.headers.set('Accept', 'application/pdf');

    // Adding token to request
    // if (token !== "") {
    //   const tokenValue = "Bearer " + token;
    //   this.headers = this.headers.append("Authorization", tokenValue);
    // }

    // console.log("HTTP Service for Token " + token);
  }

  // postFileData(subURL, setAuth, postData) {
  //   this.setFileHeaders();
  //   return new Promise((resolve, reject) => {
  //     if (setAuth) {
  //       //this.http.post(this.baseApiUrl + subURL, postData, { headers: this.headers }).subscribe(res => {
  //       //  resolve(res);
  //       //}, (err) => {
  //       //  console.log('In http service error ' + err)
  //       //  reject(err);
  //       //  });
  //       return this.http
  //         .post(this.baseApiUrl + subURL, postData, {
  //           responseType: "blob" as "blob",
  //           headers: this.headers
  //         })
  //         .map(res => {
  //           return new Blob([res], { type: "application/pdf" });
  //         });
  //     } else {
  //       this.http.post(this.baseApiUrl + subURL, postData).subscribe(
  //         res => {
  //           resolve(res);
  //         },
  //         err => {
  //           console.log("In http service error " + err);
  //           reject(err);
  //         }
  //       );
  //     }
  //   });
  // }



}

